module.exports = __webpack_public_path__ + "img/0Q3B1621-26_H_L_Foamcore_MockedUp.000c1b78.jpg";